<!--
    Notification button with dropdown menu (Feature component)

    <NotificationSkeleton />
-->
<script setup lang="ts">
import { ALSkeleton } from '@af-lib/vue-ui';
</script>

<template>
  <div v-for="n in 3" :key="n" class="flex min-w-107 items-center gap-4.5 p-4">
    <ALSkeleton class="shrink-0" type="circular" size="s" />
    <div class="flex w-full flex-col gap-4">
      <ALSkeleton type="line" size="xs" />
      <ALSkeleton class="w-1/2" type="line" size="xs" />
    </div>
  </div>
</template>
